var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('led',{staticStyle:{"margin-left":"-0.5rem"},attrs:{"classObj":_vm.lastSeen.style,"label":_vm.lastSeen.message}})}
var staticRenderFns = []

export { render, staticRenderFns }